import { Badge } from "@/deps/ui-library";
import type { PurchaseOrderStatus } from "@/api/types";

const STATUS: Record<
  PurchaseOrderStatus,
  { label: string; scheme: "default" | "info" | "success" | "warning" | "primary" }
> = {
  draft: { label: "Draft", scheme: "default" },
  sent: { label: "Sent", scheme: "info" },
  confirmed: { label: "Confirmed", scheme: "info" },
  partiallyReceived: { label: "Partially received", scheme: "warning" },
  received: { label: "Received", scheme: "success" },
  billed: { label: "Billed", scheme: "primary" },
  cancelled: { label: "Cancelled", scheme: "default" },
};

export function PurchaseOrderStatusBadge({ status }: { status: PurchaseOrderStatus }) {
  const { label, scheme } = STATUS[status];
  return (
    <Badge variant="soft" size="sm" colorScheme={scheme}>
      {label}
    </Badge>
  );
}
